import { defineNuxtPlugin, useNuxtApp, useBoosterHead, useBoosterHydrate } from '#imports';
import vFont from '#booster/directives/vFont';
import FontList from '#booster/classes/FontList';
import { isSupportedBrowser } from '#booster/utils/browser';
import { getImageSize } from '#booster/utils/plugin.client';

import './fonts.css';

export default defineNuxtPlugin({
  name: 'booster-plugin',
  enforce: 'post',
  async setup(nuxtApp) {

    const hydrate = useBoosterHydrate();

    const fontConfig = await import('./fontConfig').then(
      module => module.default || module
    );
    const fontList = new FontList(fontConfig);

    const head = useBoosterHead();

    nuxtApp.provide('booster', {
      head,
      getImageSize,
      hydrate,
      getFont: fontList.getFont.bind(fontList),
      crossorigin: 'anonymous',
      isBrowserSupported: () => isSupportedBrowser({"regex":""}),
      targetFormats: ["webp","avif","jpg|jpeg|png|gif"],
      densities: "x1 x2"
    });

  },
  hooks: {
    'app:created'() {
      const { vueApp } = useNuxtApp();
      vueApp.use(vFont);
    }
  }
});

